import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

import { PRODUCT_DETAILS_HEADING } from 'src/components/layouts/PDP/copy';

export const trackPublicAttributesToggle = (expanded: boolean) => {
  deferTracking(() => {
    sendGAEvent({
      event: 'custom_event',
      event_category: PRODUCT_DETAILS_HEADING,
      event_action: expanded ? 'Expand' : 'Collapse',
      event_label: 'not set',
    });
  });
};
